import PropTypes from 'prop-types';

const companyStatsFormStatePropTypes = PropTypes.shape({
    hid: PropTypes.string.isRequired,
    orgNo: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
});

export default companyStatsFormStatePropTypes;
